import { faLock } from '@fortawesome/free-solid-svg-icons';
import { BigUniqueFieldDiv, IconImgAwesome, StyledDiv } from '../styles';

export function UniqueInput() {
  return (
    <BigUniqueFieldDiv>
      <StyledDiv style={{ fontSize: '14px' }}>
        <IconImgAwesome icon={faLock} />
      </StyledDiv>
      <StyledDiv style={{ fontWeight: 400, fontSize: '14px' }}>
        Unique Field
      </StyledDiv>
    </BigUniqueFieldDiv>
  );
}
